import {HistoryModel, RegionModel} from "./ui.model";

export class LatencyReportRequest {

  public data: HistoryModel;
  public regions: RegionModel[];

}
